import { render, staticRenderFns } from "./IRCaseMaintenanceGrid.vue?vue&type=template&id=dfc5a378"
import script from "./IRCaseMaintenanceGrid.vue?vue&type=script&lang=js"
export * from "./IRCaseMaintenanceGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports